import { gql } from '@apollo/client'

export const GET_PRICING_ERRORS = gql`
  query GetPricingErrors(
    $input: PricingErrorInput!
    $userIds: [ID!]
    $storeIds: [ID!]
  ) {
    pricingErrors(input: $input, userIds: $userIds, storeIds: $storeIds) {
      results {
        id
        storeId
        storeName
        productPricingId
        displayAuditId
        upc
        productName
        observedPrice
        expectedPrice
        observedUnitPrice
        expectedUnitPrice
        imageUrls
        createdAt
      }
      count
      hasMore
    }
  }
`
